import Header from "../../components/header/Header";
import { Icon } from "../../modules/icon";
import { AllBasketSectionProps } from "./Basket.types";
import BasketCard from "./BasketCard";
import CardContainer from "../../components/card/CardContainer";
import { Button } from "../../components/button";
import { useNavigate } from "react-router-dom";

const AllBaskets = ({
  baskets,
  onBookmark,
  onDelete,
  onEdit,
  showCreateBasketModalHandler,
}: AllBasketSectionProps) => {
  const navigate = useNavigate();
  return (
    <section className="flex-column gap-2">
      <Header
        title="All Baskets"
        size="h5"
        actions={
          <Button
            className="btn btn-secondary"
            onClick={showCreateBasketModalHandler}
          >
            <Icon type="fa fa-plus" />
            &nbsp; Create new basket
          </Button>
        }
      />
      <CardContainer
        children={[
          ...baskets.map((item, i) => (
            <BasketCard
              key={i}
              onClick={() => {
                navigate(`/baskets/${item.id}`);
              }}
              onBookmark={onBookmark}
              onDelete={onDelete}
              onEdit={onEdit}
              name={item.name}
              numberOfItems={item.numberOfItems}
              id={item.id}
              isBookmarked={item.isBookmarked}
            />
          )),
        ]}
        cardGap={16}
        cardMinWidth={128}
        cardMaxNumberPerRow={10}
      />
    </section>
  );
};

export default AllBaskets;
